import { BaseComponent } from '@pixelart/component-handler';

export class Burgericon extends BaseComponent {
    protected ACTIVE_CLASS: string = 'burgericon--active';
    protected FIRST_TOGGLE_CLASS: string = 'burgericon--first-toggle';

    public constructor(element: Element) {
        super(element);
    }

    public init() {
        this.setListeners();
    }

    public destroy() {
        this.$element.off('click.burgericon');
    }

    private setListeners() {
        this.$element.on('click.burgericon', this.onClick.bind(this));
    }

    private onClick(e: Event) {
        const $currentTarget = $(e.currentTarget);
        $currentTarget.toggleClass(this.ACTIVE_CLASS);
        $currentTarget.addClass(this.FIRST_TOGGLE_CLASS);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/burgericon/burgericon.class.ts